import { decode } from "base-64";

const getPath = () => {
  const path = window.location.pathname;
  const result = decodeURIComponent(path).replace(/\//g, "");
  return result;
};

const getParameter = (parameterName) => {
  var result = null,
    tmp = [];
  window.location.search
    .substr(1)
    .split("&")
    .forEach(function (item) {
      tmp = item.split("=");
      if (tmp[0] === parameterName) result = decode(tmp[1]);
    });
  return result;
};

const functions = { getPath, getParameter };

export default functions;
